import React from 'react';

const ProgramAiringsPage = () => {
  return (
    <div>
      <h2>Program Airings Page</h2>
      <p>To find program airings first search for the program you are interested in.</p>
    </div>
  );
};

export default ProgramAiringsPage; 
